(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    (() => {
  const cartRoot = document.querySelector('.cart-items__wrapper');
  if (!cartRoot || cartRoot.dataset.riveliaCartMounted === 'true') return;
  cartRoot.dataset.riveliaCartMounted = 'true';

  const changeCartLine = async (id, quantity) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id, quantity })
    });
    if (!response.ok) throw new Error('Impossible de modifier le panier.');
    return response.json();
  };

  const addItems = async (items) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items })
    });
    if (!response.ok) throw new Error('Impossible de mettre à jour le panier.');
    return response.json();
  };

  const addFullPriceMasks = async (variantId, quantity) => {
    return addItems([{ id: Number(variantId), quantity }]);
  };

  const addSoloPod = async (variantId, quantity, bundleId) => {
    return addItems([{
      id: Number(variantId),
      quantity,
      properties: {
        _rivelia_bundle_id: bundleId,
        _rivelia_role: 'Pod 1'
      }
    }]);
  };

  const addStandalonePods = async (variantId, quantity) => {
    const count = Math.max(Number(quantity) || 0, 0);
    if (!count) return;

    const stamp = Date.now();
    const items = Array.from({ length: count }, (_, index) => ({
      id: Number(variantId),
      quantity: 1,
      properties: {
        _rivelia_bundle_id: 'solo-' + stamp + '-' + index,
        _rivelia_role: 'Pod 1'
      }
    }));

    return addItems(items);
  };

  const podRows = () => Array.from(cartRoot.querySelectorAll('.pod-cart-line[data-rivelia-bundle-id][data-rivelia-role]'));

  const findBundleMate = (row, role) => {
    const bundleId = row.dataset.riveliaBundleId;
    return podRows().find((candidate) =>
      candidate !== row &&
      candidate.dataset.riveliaBundleId === bundleId &&
      candidate.dataset.riveliaRole === role
    );
  };

  const normalizeOrphanSecondPod = async () => {
    const orphan = podRows().find((row) =>
      row.dataset.riveliaRole === 'Pod 2' &&
      !findBundleMate(row, 'Pod 1')
    );
    if (!orphan) return;

    const standardVariant = orphan.dataset.riveliaStandardVariant;
    const quantity = Number(orphan.dataset.riveliaQuantity || 1);
    const bundleId = orphan.dataset.riveliaBundleId;
    if (!standardVariant || !bundleId) return;

    try {
      await changeCartLine(orphan.dataset.key, 0);
      await addSoloPod(standardVariant, quantity, bundleId);
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  const normalizePodQuantities = async () => {
    const oversized = podRows().filter((row) => Number(row.dataset.riveliaQuantity || 1) > 1);
    if (!oversized.length) return false;

    try {
      for (const row of oversized) {
        const quantity = Number(row.dataset.riveliaQuantity || 1);
        const standardVariant = row.dataset.riveliaStandardVariant;
        if (!standardVariant || quantity <= 1) continue;

        await changeCartLine(row.dataset.key, 1);
        await addStandalonePods(standardVariant, quantity - 1);
      }

      window.location.reload();
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const normalizePromoMask = async () => {
    const promos = Array.from(cartRoot.querySelectorAll('[data-rivelia-promo-mask]'));
    if (!promos.length) return;

    let changed = false;
    let promoKept = false;

    try {
      for (const promo of promos) {
        const quantity = Number(promo.dataset.promoQuantity || 1);
        const lineKey = promo.dataset.lineKey;
        const fullPriceVariant = promo.dataset.fullPriceVariant;
        const promoRow = promo.closest('tr[data-rivelia-bundle-id]');
        const bundleId = promoRow?.dataset.riveliaBundleId;
        const hasPod = Boolean(
          bundleId &&
          podRows().find((row) =>
            row.dataset.riveliaBundleId === bundleId &&
            row.dataset.riveliaRole === 'Pod 1'
          )
        );

        if (!lineKey || !fullPriceVariant) continue;

        if (!hasPod || promoKept) {
          await changeCartLine(lineKey, 0);
          await addFullPriceMasks(fullPriceVariant, Math.max(quantity, 1));
          changed = true;
          continue;
        }

        promoKept = true;

        if (quantity > 1) {
          await changeCartLine(lineKey, 1);
          await addFullPriceMasks(fullPriceVariant, quantity - 1);
          changed = true;
        }
      }

      if (changed) window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  cartRoot.addEventListener('click', async (event) => {
    const removeButton = event.target.closest('.cart-items__remove');
    const row = removeButton?.closest('.pod-cart-line[data-rivelia-bundle-id][data-rivelia-role]');

    if (removeButton && row && row.dataset.riveliaRole === 'Pod 1') {
      const bundleId = row.dataset.riveliaBundleId;
      const secondPod = findBundleMate(row, 'Pod 2');
      const promoMask = Array.from(cartRoot.querySelectorAll('[data-rivelia-promo-mask]')).find((promo) => {
        const promoRow = promo.closest('tr[data-rivelia-bundle-id]');
        return promoRow?.dataset.riveliaBundleId === bundleId;
      });

      const canNormalizeSecondPod = Boolean(
        secondPod &&
        secondPod.dataset.riveliaStandardVariant &&
        bundleId
      );
      const canNormalizePromoMask = Boolean(
        promoMask &&
        promoMask.dataset.lineKey &&
        promoMask.dataset.fullPriceVariant
      );

      if (canNormalizeSecondPod || canNormalizePromoMask) {
        event.preventDefault();
        event.stopImmediatePropagation();
        removeButton.disabled = true;

        try {
          await changeCartLine(row.dataset.key, 0);

          if (canNormalizeSecondPod) {
            const quantity = Number(secondPod.dataset.riveliaQuantity || 1);
            await changeCartLine(secondPod.dataset.key, 0);
            await addSoloPod(secondPod.dataset.riveliaStandardVariant, quantity, bundleId);
          }

          if (canNormalizePromoMask) {
            const quantity = Number(promoMask.dataset.promoQuantity || 1);
            await changeCartLine(promoMask.dataset.lineKey, 0);
            await addFullPriceMasks(promoMask.dataset.fullPriceVariant, Math.max(quantity, 1));
          }

          window.location.reload();
        } catch (error) {
          removeButton.disabled = false;
          window.alert(error?.message || 'Impossible de modifier le panier.');
        }
        return;
      }
    }

    const maskButton = event.target.closest('.rivelia-add-mask-full-price');
    if (!maskButton) return;

    maskButton.disabled = true;
    try {
      await addFullPriceMasks(maskButton.dataset.fullPriceVariant, 1);
      window.location.reload();
    } catch (error) {
      maskButton.disabled = false;
      window.alert(error?.message || 'Impossible d’ajouter le masque.');
    }
  }, true);

  let riveliaNormalizationRunning = false;

  const normalizeRiveliaCart = async () => {
    if (riveliaNormalizationRunning) return;
    riveliaNormalizationRunning = true;

    try {
      const podChanged = await normalizePodQuantities();
      if (podChanged) return;

      await normalizeOrphanSecondPod();
      await normalizePromoMask();
    } finally {
      riveliaNormalizationRunning = false;
    }
  };

  normalizeRiveliaCart();

  const observer = new MutationObserver(() => {
    window.clearTimeout(cartRoot._riveliaNormalizeTimer);
    cartRoot._riveliaNormalizeTimer = window.setTimeout(normalizeRiveliaCart, 80);
  });

  observer.observe(cartRoot, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rivelia-bundle-selector"] && !Shopify.designMode) return;
  try {
    (() => {
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const findPicker = (bundle) => bundle.parentElement?.querySelector('.rivelia-native-picker');

  const chooseNative = (bundle, index, value) => {
    const picker = findPicker(bundle);
    if (!picker) return false;

    const radios = Array.from(picker.querySelectorAll('input[type="radio"][data-fieldset-index="' + index + '"]'));
    const radio = radios.find((input) => input.value === value);
    if (radio) {
      if (!radio.checked) radio.click();
      return true;
    }

    const selects = Array.from(picker.querySelectorAll('select.variant-option__select'));
    const select = selects[index];
    if (select) {
      const option = Array.from(select.options).find((item) => item.value === value);
      if (option) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }

    return false;
  };

  const getActiveCard = (bundle) => {
    const checked = bundle.querySelector('input[name^="rivelia-offer-"]:checked');
    return checked?.closest('[data-offer-card]') || bundle.querySelector('[data-offer-card="duo"]');
  };

  const syncCards = (bundle) => {
    const active = getActiveCard(bundle);
    bundle.querySelectorAll('[data-offer-card]').forEach((card) => {
      card.classList.toggle('is-selected', card === active);
    });
  };

  const applySelection = async (bundle) => {
    const card = getActiveCard(bundle);
    if (!card) return;

    const offer = card.dataset.offerCard || 'duo';
    const size1 = offer === 'duo'
      ? (card.querySelector('[data-size-duo-one]')?.value || 'S')
      : (card.querySelector('[data-size-solo]')?.value || 'S');

    chooseNative(bundle, 0, '1 Pod');
    await sleep(80);
    chooseNative(bundle, 1, size1);
    await sleep(60);
    chooseNative(bundle, 2, '—');
  };

  const getVariantId = (bundle, type, size) => {
    const key = type + size.charAt(0).toUpperCase() + size.slice(1).toLowerCase();
    return Number(bundle.dataset[key] || 0);
  };

  const addSplitBundle = async (bundle, form) => {
    if (form.dataset.riveliaSubmitting === 'true') return;
    form.dataset.riveliaSubmitting = 'true';

    const card = getActiveCard(bundle);
    if (!card) {
      delete form.dataset.riveliaSubmitting;
      return;
    }

    const offer = card.dataset.offerCard || 'duo';
    const withMask = Boolean(card.querySelector('[data-rivelia-mask]')?.checked);
    const size1 = offer === 'duo'
      ? (card.querySelector('[data-size-duo-one]')?.value || 'S')
      : (card.querySelector('[data-size-solo]')?.value || 'S');
    const size2 = offer === 'duo'
      ? (card.querySelector('[data-size-duo-two]')?.value || 'S')
      : null;

    const firstId = getVariantId(bundle, 'standard', size1);
    const secondId = size2 ? getVariantId(bundle, 'second', size2) : 0;
    const maskId = Number(bundle.dataset.maskVariant || 0);

    if (!firstId || (offer === 'duo' && !secondId) || (withMask && !maskId)) {
      throw new Error('Une variante de l’offre est introuvable.');
    }

    const bundleId = String(Date.now());
    const items = [
      {
        id: firstId,
        quantity: 1,
        properties: {
          _rivelia_bundle_id: bundleId,
          _rivelia_role: 'Pod 1'
        }
      }
    ];

    if (offer === 'duo') {
      items.push({
        id: secondId,
        quantity: 1,
        properties: {
          _rivelia_bundle_id: bundleId,
          _rivelia_role: 'Pod 2'
        }
      });
    }

    if (withMask) {
      items.push({
        id: maskId,
        quantity: 1,
        properties: {
          _rivelia_bundle_id: bundleId,
          _rivelia_role: 'Masque'
        }
      });
    }

    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    try {
      const response = await fetch((window.Theme?.routes?.cart_add_url || '/cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items })
      });

      const payload = await response.json();
      if (!response.ok) {
        throw new Error(payload?.description || payload?.message || 'Impossible d’ajouter l’offre au panier.');
      }

      window.location.assign(window.Theme?.routes?.cart_url || '/cart');
    } catch (error) {
      delete form.dataset.riveliaSubmitting;
      if (submitButton) submitButton.disabled = false;
      window.alert(error?.message || 'Impossible d’ajouter l’offre au panier.');
    }
  };

  const mount = (bundle) => {
    if (bundle.dataset.mounted === 'true') return;
    bundle.dataset.mounted = 'true';

    bundle.querySelectorAll('[data-offer-card]').forEach((card) => {
      card.addEventListener('click', (event) => {
        if (event.target.closest('select, input, label')) return;
        const radio = card.querySelector('input[name^="rivelia-offer-"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    bundle.addEventListener('change', (event) => {
      const card = event.target.closest('[data-offer-card]');
      if (card) {
        const radio = card.querySelector('input[name^="rivelia-offer-"]');
        if (radio && !radio.checked) radio.checked = true;
      }
      syncCards(bundle);
      applySelection(bundle);
    });

    syncCards(bundle);
    setTimeout(() => applySelection(bundle), 100);

    const details = bundle.closest('.product-details');
    const productForm = details?.querySelector('product-form-component');
    const form = productForm?.querySelector('form');

    if (form) {
      form.dataset.riveliaSplitBundle = 'true';
    }

    const trust = bundle.querySelector('[data-rivelia-trust]');
    const buyButtons = details?.querySelector('.buy-buttons-block');
    if (trust && buyButtons && trust.parentElement === bundle) {
      buyButtons.insertAdjacentElement('afterend', trust);
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const details = form.closest('.product-details');
    const bundle = details?.querySelector('[data-rivelia-bundle]');
    if (!bundle) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addSplitBundle(bundle, form);
  }, true);

  document.querySelectorAll('[data-rivelia-bundle]').forEach(mount);
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-rivelia-bundle]').forEach(mount);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
